export default __webpack_public_path__ + "static/media/books.a5871deb.svg";